export default "__VITE_ASSET__2g2apVmu__"